import { render, staticRenderFns } from "./80.vue?vue&type=template&id=b82bad28&scoped=true&"
var script = {}
import style0 from "./80.vue?vue&type=style&index=0&id=b82bad28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b82bad28",
  null
  
)

export default component.exports